/*=========================================================================================
  File Name: moduleChatState.js
  Description: Chat Module State

==========================================================================================*/

export default {
  // Stores All Contacts
  whitelistContacts: [],
  blacklistContacts: [],

  // Stores Chat data(log)
  chats: {},

  activeChatUser: null,

  videoChatData: null,
  onCallUser: null,
  isCaller: false
}
